var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.3291 1.4248C4.74332 1.4248 5.0791 1.76059 5.0791 2.1748V2.84973H12.7505V2.1748C12.7505 1.76059 13.0863 1.4248 13.5005 1.4248C13.9147 1.4248 14.2505 1.76059 14.2505 2.1748V2.95519C15.3769 3.28011 16.2008 4.31871 16.2008 5.54973L16.2008 13.7998C16.2008 15.291 14.9919 16.4998 13.5008 16.4998H4.50078C3.00961 16.4998 1.80078 15.291 1.80078 13.7998V5.54973C1.80078 4.38225 2.54177 3.38784 3.5791 3.01113V2.1748C3.5791 1.76059 3.91489 1.4248 4.3291 1.4248ZM4.88574 5.9248C4.47153 5.9248 4.13574 6.26059 4.13574 6.6748C4.13574 7.08902 4.47153 7.4248 4.88574 7.4248H13.05C13.4642 7.4248 13.8 7.08902 13.8 6.6748C13.8 6.26059 13.4642 5.9248 13.05 5.9248H4.88574Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar_icon.8cad8b49c7b12576102681237ace3af2.svg";
export { ForwardRef as ReactComponent };